// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import { productCarouselStyles } from "@synd/Overrides/Widgets/Common/ProductCarousel";
import { hideElementOnPrint } from "@synd/XDL/Utilities";
import xScreen from "@synd/XDL/Utilities/xScreen";
import { css } from "styled-components";

productCarouselStyles.titleText = {
    variant: "h2Sans" as any,
    css: css`
        margin-bottom: 24px;
    `,
};

productCarouselStyles.miniCardStyles = {
    productGridContainerStyles: {
        container: {
            css: css`
                &&&& {
                    min-width: 317px;
                    max-width: 317px;
                }
                display: grid;
                grid-template-columns: 96px minmax(0, 1fr);
                grid-template-rows: 1fr auto auto 1fr;
                gap: 8px 12px;
                height: 100%;
                & > .top-section {
                    grid-column: 1 / 2;
                    grid-row: 1 / 5;
                }
                & > .middle-section {
                    grid-column: 2 / 3;
                    grid-row: 1 / 4;
                }
                & > .bottom-section {
                    grid-column: 1 / 3;
                    grid-row: 4 / 6;
                    display: grid;
                    grid-template-columns: 96px minmax(0, 1fr);
                    grid-template-rows: 1fr;
                }
            `,
        },
        image: {
            css: css`
                width: 100%;
                height: 100%;
                gap: 8px;
                display: flex;
                flex-direction: column;
                &,
                & [data-test-selector="productImage"] {
                    width: 96px;
                    height: 96px;
                    min-width: 96px;
                    max-width: 96px;
                    min-height: 96px;
                    max-height: unset;
                }
            `,
        },
        availability: {
            css: css`
                grid-column: 2 / 3;
                grid-row: 1 / 2;
                z-index: 2;
            `,
        },
        price: {
            css: css`
                grid-column: 2 / 3;
                grid-row: 2/3;
                z-index: 2;
            `,
        },
        addToCartActions: {
            css: css`
                grid-column: 1 / 3;
                grid-row: 3 / 4;
            `,
        },
        addToList: {
            css: css`
                grid-column: 2 / 3;
                grid-row: 4 / 5;
                justify-content: end;
                margin-top: 0;
            `,
        },
    },
};

productCarouselStyles.carouselProductCondensedStyles = {
    productGridContainerStyles: {
        container: {
            css: css`
                &&&& {
                    max-width: 204px;
                }
            `,
        },
        image: {
            css: css`
                ${StyledButton} {
                    min-width: 204px;
                    max-width: 204px;
                    min-height: 204px;
                    max-height: 204px;
                    height: 204px;
                }
                & img {
                    object-fit: contain;
                }
            `,
        },
    },
};

productCarouselStyles.swiperStyles = {
    container: {
        css: css`
            ${StyledButton} {
                ${xScreen("lte", "md")} {
                    &.xng-carousel-next:not(.show-arrows-outside) {
                        right: 0;
                    }
                    &.xng-carousel-prev:not(.show-arrows-outside) {
                        left: 0;
                    }
                }
            }
        `,
    },
};

productCarouselStyles.condensedSwiperStyles = {
    container: {
        css: css`
            ${StyledButton} {
                ${xScreen("lte", "md")} {
                    &.xng-carousel-next:not(.show-arrows-outside) {
                        right: 0;
                    }
                    &.xng-carousel-prev:not(.show-arrows-outside) {
                        left: 0;
                    }
                }
            }
        `,
    },
};

productCarouselStyles.wrapper = {
    css: css`
        ${hideElementOnPrint}
    `,
};
